import {Ease} from '@colonist/pixi'
import {UIGameMechanic} from '../../../../shared/scripts/ui_game/UIGameEventController'
import {UIMGameManager} from '../UIMGameManager'
import {GameStateEnums} from '../../../../../shared/GameEnums'

import UIGameEventEnums = GameStateEnums.UIGameEventEnums
import {SectionBgView} from '../../../../shared/scripts/ui_canvas_engine/SectionBgView'
import {UIUtilsEjsVariables} from '../../../../shared/scripts/UIUtilsEjsVariables'

export class UIMGameAnimationController implements UIGameMechanic {
    private readonly animation: Ease
    private readonly responsiveView: SectionBgView[] = []
    private currentFeedState: boolean = false

    constructor(uiGameManager: UIMGameManager) {
        uiGameManager.eventController.registerUIGameMechanic(this)

        this.animation = new Ease({useRef: false})
    }

    onEvent(data: any, eventType: any) {
        switch(eventType) {
            case UIGameEventEnums.ToggleChatFeed:
            case UIGameEventEnums.ToggleLogFeed: this.onFeedStateChanged(data); break
            default: break
        }
    }

    registerForFeedMechanics(container: SectionBgView) {
        this.responsiveView.push(container)
    }

    unregisterForFeedMechanics(container: SectionBgView) {
        const index = this.responsiveView.indexOf(container)
        if(index == -1) return
        this.responsiveView.splice(index, 1)
    }

    onFeedStateChanged(currentState: boolean) {
        if(UIUtilsEjsVariables.isUserOnTabletApp) return
        if(this.currentFeedState == currentState) return
        this.currentFeedState = currentState
        const heightOfFeed = window.innerHeight * 0.2
        const animationTime = 200

        this.responsiveView.forEach((container: SectionBgView) => {
            const finalPosition = currentState ? container.initialPosition.y - heightOfFeed : container.initialPosition.y
            if(finalPosition != container.y) {
                this.animation.add(container, {y: finalPosition}, {duration: animationTime})
            }
        })
    }
}
